<template>
  <div>
    <h5>
      <span class="badge bg-danger" v-if="$store.getters.device(extra.serial)[extra.name] === 0">OFF</span>
      <span class="badge bg-warning" v-if="$store.getters.device(extra.serial)[extra.name] === 1">KÄSI</span>
      <span class="badge bg-success" v-if="$store.getters.device(extra.serial)[extra.name] === 2">AUTO</span>
      {{ title }}
    </h5>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra']
}
</script>
